import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const FolderIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M3.3 18.7V5.3h6.175l2 2H20.7v11.4H3.3ZM4 18h16V8h-8.8l-2-2H4v12Z"
      />
    </svg>
  </IconWrapper>
));
